function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-7-3h24v24H-7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5 2.83L8.17 6l1.41-1.41L5 0 .41 4.59 1.83 6 5 2.83zm0 12.34L1.83 12 .42 13.41 5 18l4.59-4.59L8.17 12 5 15.17z",
  fill: "#FFF"
}));

function SvgExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18
  }, props), _ref);
}

export default SvgExpand;